/** Resolve after `ms` milliseconds (for retry back-off inside async flows). */
export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
